function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: bg;\n  padding: 5 20 6;\n  border: none;\n\n  margin: 0;\n  padding: 2;\n  list-style: none;\n\n  box-shadow: inset 1px 1px 0px 1px ", ",\n    inset 0 0 0 1px ", ", 1px 1px 0 1px ", ";\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled from '@xstyled/styled-components';
import { th } from '@xstyled/system';
import ListItem from './ListItem';
import Divider from './ListDivider';
var StyledList = styled.ul(_templateObject(), th('colors.white'), th('colors.grays.3'), th('colors.black'), function (_ref) {
  var width = _ref.width;
  return "\n    width: ".concat(width, "px;\n  ");
});
var List = Object.assign(StyledList, {
  Item: ListItem,
  Divider: Divider
});
List.displayName = 'List';
List.defaultProps = {
  width: 200
};
export default List;